import { useState } from 'react'
import { recarregarApp } from '../dados/recarregar.js'

/// O "F5" no cabeçalho. Ver dados/recarregar.ts.
export function BotaoAtualizar() {
  const [recarregando, setRecarregando] = useState(false)

  return (
    <button
      type="button"
      onClick={() => {
        setRecarregando(true)
        void recarregarApp()
      }}
      disabled={recarregando}
      title="Atualizar (como o F5 do navegador)"
      aria-label="Atualizar o sistema"
      className="ml-auto grid h-10 w-10 shrink-0 place-items-center rounded-full text-marinho-100 transition hover:bg-white/10 hover:text-white disabled:opacity-70"
    >
      <svg
        viewBox="0 0 24 24"
        className={`h-5 w-5 ${recarregando ? 'animate-spin' : ''}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        aria-hidden
      >
        <path d="M20 12a8 8 0 1 1-2.34-5.66" strokeLinecap="round" />
        <path d="M20 4v5h-5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  )
}
